// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomQuotes = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '44',
      height: '34',
      viewBox: '0 0 44 34',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.4645 16.5641C15.5591 16.9377 19.2767 20.5494 19.2767 25.1575C19.2767 30.0146 15.146 33.8755 9.77606 33.8755C4.13073 33.8755 0 30.1392 0 24.1612C0 12.2051 9.50068 3.36263 14.1822 0L17.0737 3.61172C15.0083 5.85348 11.4283 10.0879 10.4645 16.5641ZM34.9735 16.6886C40.0681 17.0623 43.7857 20.674 43.7857 25.2821C43.7857 30.1392 39.655 34 34.285 34C28.6397 34 24.509 30.2637 24.509 24.2857C24.509 12.3297 34.0097 3.48718 38.6912 0.12454L41.5827 3.73626C39.5173 5.97802 35.9373 10.2124 34.9735 16.6886Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomQuotes };
